export const ru = {
  journal: 'Журнал',
  moreButtonTitle: 'ещё',
};

export default ru;
